<template>
    <div class="internalremarks">
        <div class="internalRemarksHead" >
            <div class="internalRemarksName">
                <span>{{replayInfo.operatorInfo.name}}</span>
                <span style="margin-left: 5px">
                      <span v-if="replayInfo.newVal.sendMail===null">内部备注</span>
                </span>

            </div>
            <div class="internalRemarkTime">{{dateFormat(replayInfo.createTime)}}</div>
        </div>
        <div class="internalRemarksContain" >
          <span class="text-content" v-html="replayInfo.newVal.content">{{replayInfo.newVal.content}}</span>
        </div>
                                                <div
                                                    v-if="showPreview"
                                                    style="
                                                        width: 100vw;
                                                        height: 100vh;
                                                        z-index: 10000;
                                                        position: fixed;
                                                        top: 0;
                                                        left: 0;
                                                        background-color: rgba(0, 0, 0, 0.8);
                                                      ">
                                               <div
                                                    @click="showPreview = false"
                                                    style="
                                                          color: white;
                                                          font-size: 30px;
                                                          padding: 30px 30px 15vh;
                                                          text-align: right;
                                                          cursor: pointer;
                                                        ">X
                                               </div>
                                                <img
                                                    style="max-height: 60vh; max-width: 60vw;margin: auto;display: block;"
                                                    :src="previewImageUrl"
                                                    alt
                                                    srcset
                                                  />
                                 </div>
    </div>
</template>

<script>
    export default {
        name: "InternalRemarks",
        data(){
            return{
                content:'',
                sourceName:'',
                previewImageUrl:'',
                showPreview:false
            }
        },
        props:{
            replayInfo:{
                type:Object,
                default(){
                    return {}
                }
            },
            refrsh:Number,
            source:String
        },
        mounted() {
          console.log(this.replayInfo)
            this.$nextTick(() => {
                window.previewImage=this.previewImage;
            })
            if(this.replayInfo.changeType==='REPLY')
            {
                if(this.replayInfo.newVal!==undefined)
                    this.content=this.replayInfo.newVal.content
            }
            let a=document.getElementsByClassName('text-content')
            for (let i=0;i < a.length;i++)
            {
                for (let j=0;j<a[i].children.length;j++)
                {

                    let aa=a[i].children[j].getElementsByTagName('a')
                    for (let k=0;k<aa.length;k++)
                    {
                        aa[k].setAttribute('download',aa[k].attributes[2].value)

                    }

                }
            }

        },
        methods:{
            previewImage(_this) {
                this.showPreview = true;
                this.previewImageUrl = _this.src;
            },
            dateFormat(time){
                let date=new Date(time);
                let year=date.getFullYear();
                /* 在日期格式中，月份是从0开始的，因此要加0
                 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
                 * */
                let month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                let day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                let hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
                let minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
                let seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
                // 拼接
                return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
            }
        },
        watch:{
            refrsh(a){
                if(a===1)
                    console.log('aaaa')
            },
            replayInfo:function (a) {
                this.replayInfo=a
                console.log(a)
            },

        },
    }
</script>

<style  lang="less">
.internalremarks{
  margin: 16px 0;
}
    .internalRemarksHead{
        display: flex;
        justify-content: space-between;
       height: 32px;
        line-height: 32px;
        background-color:#FF9500 ;
        border-top-right-radius: 5px;
        border-top-left-radius:5px ;
        color: white;

    }
    .internalRemarksName{
        margin-left: 10px;
        font-size: 13px;
    }
    .internalRemarkTime{
        margin-right: 10px;
        font-size: 13px;
    }
    .internalRemarksContain{
        height: auto;
        font-size: 13px;
        text-indent: 2em;
        padding: 10px;
        background-color: white;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;

    }
.text-content img{
   max-width: 170px!important;
}
</style>